<iframe id="configurator-frame" class="configurator" [src]="origin" >
</iframe>
